__turbopack_context__.v({
  "image-area": "GuideImageArea-module-scss-module__Ya1CHG__image-area",
  "image-area__isCard": "GuideImageArea-module-scss-module__Ya1CHG__image-area__isCard",
});
